export
const name: string = "Lines";

export
const preproc: string = ``;

export
const declaration: string = `
    attribute vec3  a_position;
    attribute vec3  a_normal;
    attribute float a_manipulation;

    #if !defined(PRIMITIVE_ID_PASS)
    attribute float a_distance;
    attribute float a_visibility;
    #endif

    #if defined(PRIMITIVE_ID_PASS)
    attribute float a_primitive_id;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    attribute float a_selection;
    #endif

    uniform   mat4  u_view_projection;
    uniform   mat4 u_model_transformation; // this supply the model in model view projectionm matrix as we do not have per mesh model trafo, but met fat model
    uniform   mat4  u_manipulator;

    uniform   vec2  u_viewport;
    uniform   float u_line_width;
    uniform   float u_viewport_scale;
`;

export
const varyings: string = `
    #if defined(PRIMITIVE_ID_PASS)
    varying vec4 v_primitive_id;
    #else
    varying float v_distance_from_origin;
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
    varying   float v_selected;
    #endif
`;

export
const implementation: string = `
    void main()
    {
    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
        v_selected = a_selection;
    #endif

    #if !defined(PRIMITIVE_ID_PASS)
        v_distance_from_origin = a_distance;
    #endif

    #if defined(PRIMITIVE_ID_PASS)
        v_primitive_id = intToVec4(a_primitive_id);
    #endif

        vec2 viewport = u_viewport * u_viewport_scale;

        vec4 position = vec4(a_position, 1.0);
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif
        vec4 frag_pos = u_view_projection * u_model_transformation * position;
        frag_pos = frag_pos / frag_pos.w; // screen pos
        frag_pos = frag_pos * 0.5 + 0.5;  // transform from -1 .. 1 to 0 .. 1
        frag_pos.x = frag_pos.x * viewport.x; // transform from 0 .. 1 to 0 .. width
        frag_pos.y = frag_pos.y * viewport.y; // transform from 0 .. 1 to 0 .. height

        position = vec4(a_position + a_normal, 1.0);
    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif
        vec4 frag_pos2 = u_view_projection * u_model_transformation * position;
        frag_pos2 = frag_pos2 / frag_pos2.w;
        frag_pos2 = frag_pos2 * 0.5 + 0.5;
        frag_pos2.x = frag_pos2.x * viewport.x;
        frag_pos2.y = frag_pos2.y * viewport.y;

        float dist = distance(frag_pos2.xy, frag_pos.xy);
        float w = 1.0;
        if (dist > 0.001) {
            w = (u_line_width * u_viewport_scale) / (dist * 3.0);
        }

    #if defined(PRIMITIVE_ID_PASS)
        position = vec4(a_position + w * a_normal, 1.0);
    #else // other passes
        position = vec4(a_position + w * a_normal, 1.0) * a_visibility;
    #endif

    #ifdef MANIPULATOR_ENABLED
        if (a_manipulation > 0.5) {
            position = u_manipulator * position;
        }
    #endif

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS)
        setVaryingsForLighting0();
    #endif

    #ifdef CLIPPING_PLANE
        setVaryingsForCPlane(u_model_transformation * position);
    #endif

        gl_Position = u_view_projection * u_model_transformation * position;

    #if !defined(DEPTH_PASS) && !defined(PRIMITIVE_ID_PASS) && defined(LOGDEPTH)
     	setVaryingsForLogarithmicDepthBuffer();
    #endif
    }
`;
